import { TableCell } from '@material-ui/core';
import styled from 'styled-components';

interface StyleProps {
  background?: string;
  columnWidth?: number;
}

export const Container = styled.div`
  width: 100%;
  height: 100%;

  .gridScrollBody,
  .gridScrollFooter {
    scrollbar-gutter: stable;

    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: #8850bf rgba(136, 80, 191, 0.18);
  }

  /* WebKit (Chrome/Edge/Safari) */
  .gridScrollBody::-webkit-scrollbar,
  .gridScrollFooter::-webkit-scrollbar {
    width: 12px;
    height: 30px;
  }

  .gridScrollBody::-webkit-scrollbar-track,
  .gridScrollFooter::-webkit-scrollbar-track {
    background: rgba(136, 80, 191, 0.18);
    border-radius: 2px; /* mais quadrada */
  }

  .gridScrollBody::-webkit-scrollbar-thumb,
  .gridScrollFooter::-webkit-scrollbar-thumb {
    background: #8850bf;
    border-radius: 2px; /* mais quadrada */
    border: 2px solid rgba(136, 80, 191, 0.18);
  }

  .gridScrollBody::-webkit-scrollbar-thumb:hover,
  .gridScrollFooter::-webkit-scrollbar-thumb:hover {
    background: #57069e;
  }

  .gridScrollBody::-webkit-scrollbar-corner,
  .gridScrollFooter::-webkit-scrollbar-corner {
    background: rgba(136, 80, 191, 0.18);
  }

  .gridScrollBody {
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1 1 auto;
  }

  .gridScrollFooter {
    overflow-x: auto;
    overflow-y: hidden;
    flex: 0 0 auto;
    pointer-events: auto;
  }

  .disabled-linear-progress {
    div {
      background: transparent !important;
    }
  }

  .highlightCell {
    background: rgba(136, 80, 191, 0.12);
  }

  .totalizerRow td {
    font-weight: 600;
    border-top: 2px solid #8850bf;
    font-size: 0.95rem;
  }

  .totalizerCell {
    background: #f5f5f5;
  }

  .totalizerCell.highlightCell {
    background: rgba(136, 80, 191, 0.12) !important;
  }
`;

export const CustomTableCell = styled(TableCell)<StyleProps>`
  position: sticky;
  background: ${(props) => props.background ?? '#ffffff'};
  min-width: ${(props) => props.columnWidth};
  max-width: ${(props) => props.columnWidth};
  background: ${(props) => (props.background ? props.background : '#ffffff')};

  button {
    color: #48778c;
    &:hover {
      background: ${(props) =>
        props.background ? props.background : '#ffffff'} !important;
      opacity: 0.8;
    }
  }
`;

export const ColumnSeparator = styled.div`
  color: rgba(224, 224, 224, 1);
  left: -12px;
  display: flex;
  z-index: 100;
  position: absolute;
  flex-direction: column;
  justify-content: center;
  min-height: 56px;
  opacity: 1;
  top: 0;

  .MuiSvgIcon-root {
    width: 1.1em;
  }
`;
